

import { Pipe, PipeTransform } from '@angular/core';
import { Attendee } from 'src/models/attendee';
import { EventAttendee } from 'src/models/eventAttendee';

@Pipe({
    name: 'filterEventAttendee',
    pure: false
})
export class FilterEventAttendee implements PipeTransform {
    transform(items: EventAttendee[], conditions: string): any {
        return conditions ? items.filter(item =>
            item.Name?.toLowerCase().indexOf(conditions?.toLowerCase()) > -1 ||
            item.ServiceName?.toLowerCase().indexOf(conditions?.toLowerCase()) > -1 ||
            item.Gender?.toLowerCase() == conditions?.toLowerCase() ||
            item.PaidItemNames?.toLowerCase().indexOf(conditions?.toLowerCase()) > -1
        ) : items;
    }
}



@Pipe({
    name: 'filterAttendee',
    pure: false
})
export class FilterAttendee implements PipeTransform {
    transform(items: Attendee[], conditions: string): any {
        return conditions ? items.filter(item =>
            item.ProfileName?.toLowerCase().indexOf(conditions?.toLowerCase()) > -1 ||
            item.Gender?.toLowerCase() == conditions?.toLowerCase() ||
            item.ServiceName?.toLowerCase().indexOf(conditions?.toLowerCase()) > -1 ||
            item.City?.toLowerCase().indexOf(conditions?.toLowerCase()) > -1
        ) : items;
    }
}
